import React from 'react';
import {useSelector} from 'react-redux';
import './_club-placeholder-content.scss';
import MobileFilterButton from "../search-bar-filter-components/mobile-filter-button/mobile-filter-button";
import PlaceholderImage from '../../assets/icons/sports-illustration.svg'
import {RootState} from '../../../store/configureStore';
import {Config} from '../../../constants/Config';

const baseClass = 'clubPlaceholderComponent'
const MobileViewWidth = Config.breakpoints.large.width;

interface ClubPlaceholderContentTypes {
  placeHolderText: string
  tenant: string
}

const ClubPlaceholderContent = (props: ClubPlaceholderContentTypes): JSX.Element => {
  const isMobileSearchVisible = useSelector((state: RootState) => state.clubFinderSearchBarStore.isMobileSearchVisible);
  const parentWidth = useSelector((state: RootState) => state.widgetConfigurationSettings.widgetParentWidth);
  const selectedLocation = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedLocation);

  let buttonLocationText: string = '',
    buttonFormatText: string | null = '',
    buttonForText: string | null = '';

  if (props.tenant == Config.tenantList.nzcTenant) {
    buttonLocationText = 'Where do you want to play?';
    buttonFormatText = 'Location - Format';
    buttonForText = 'For'
  } else if (props.tenant == Config.tenantList.aflTenant) {
    buttonLocationText = 'Find a suburb or club';
    buttonFormatText = null;
    buttonForText = null
  } else if (props.tenant == Config.tenantList.naTenant) {
    buttonLocationText = 'Find a suburb or club';
    buttonFormatText = null;
    buttonForText = null
  }

  return (
    <>
      {parentWidth > MobileViewWidth && props.tenant == 'nzc' && (
        <div className={`${baseClass}`}>
          <div className={`${baseClass}--placeholder-image-container`}>
            <img src={PlaceholderImage} className={'placeholder-image'} alt="logo"/>
          </div>
          <div className={`${baseClass}--placeholder-text`}>
            {props.placeHolderText}
          </div>
        </div>
      )}
      {parentWidth <= MobileViewWidth && !isMobileSearchVisible && (
        <div className={`${baseClass}`}>
          {!selectedLocation && (
            <MobileFilterButton location={buttonLocationText} format={buttonFormatText} for={buttonForText}
                                tenant={props.tenant}/>
          )}

          {selectedLocation && (
            <div className={`${baseClass}--placeholder-text`}>
              {props.placeHolderText}
            </div>
          )}

        </div>
      )}
    </>
  )
}

export default ClubPlaceholderContent;
